"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import GradualBlur from "@/app/components/GradualBlur";

/**
 * Fixed strip pinned to the bottom of the viewport so content scrolling
 * down fades/blurs out instead of hard-clipping at the screen edge.
 * GradualBlur's own target="parent" mode positions absolutely within
 * the nearest positioned ancestor — this div supplies that ancestor via
 * position:fixed rather than GradualBlur's own target="page" mode, per
 * spec (scoped overlay, not a page-wide fixed layer).
 *
 * Portaled to document.body rather than rendered inline in each page's
 * <main> — some sections (decorative shapes, cards) create their own
 * stacking contexts, which was letting them paint over the fixed strip
 * mid-scroll and show up as gaps in the blur. A body-level portal keeps
 * it in one stacking context, always on top, for the whole page.
 */
export function GradualBlurHeader() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return createPortal(
    <div
      className="pointer-events-none"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "5rem",
        zIndex: 40,
      }}
    >
      <GradualBlur position="bottom" target="parent" height="5rem" strength={2} curve="bezier" />
    </div>,
    document.body
  );
}
